import { render, staticRenderFns } from "./ResNumberInputField.vue?vue&type=template&id=c97d95ea&scoped=true"
import script from "./ResNumberInputField.vue?vue&type=script&lang=js"
export * from "./ResNumberInputField.vue?vue&type=script&lang=js"
import style0 from "./ResNumberInputField.vue?vue&type=style&index=0&id=c97d95ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97d95ea",
  null
  
)

export default component.exports